import IconBase from './IconBase'
import { ReactComponent } from './light/list-ul.svg'

const Icon = (props: any) => <IconBase {...props} ReactComponent={ReactComponent} />

export default Icon
